import { SET_APP_VERSION, SET_APP_ID, SET_CUSTOMER_DATA, SET_I18N_DATA, LOADING_SCREEN_SHOW, LOADING_SCREEN_HIDE, SET_IS_LIVIN_ENABLED, SET_FEATURES, SET_GUEST_LOGIN_DATA, SET_SSP_DATA, SET_SETTINGS } from "../constants/constants";
import { getFromController, logInfoToDatabase } from "./apiActions";
import { loadCustomerData, loadLifeCustomerData, signOut } from "./authActions";
import Cookies from 'universal-cookie';
import { store } from "../store/configureStore";
import { NAM_ADDRESS1, NAM_ADDRESS2, NAM_ADDRESS3, NAM_ADDRESS4, NAM_CLAIMS_EMAIL, NAM_CLIENT_CARE_EMAIL, NAM_KP_FSP, NAM_LAT, NAM_LONG, NAM_SALES_EMAIL, NAM_TEL, SA_LAT, SA_LONG, SA_ADDRESS1, SA_ADDRESS2, SA_ADDRESS3, SA_ADDRESS4, SA_TEL, SA_CLIENT_CARE_EMAIL, SA_CLAIMS_EMAIL, SA_SALES_EMAIL, SA_KP_FSP } from '../constants/internationalization';

export const setAppVersionMain = async () => {
    const dispatch = store.dispatch;
    await dispatch({ type: LOADING_SCREEN_SHOW });
    await getFromController(dispatch, 'BuildVersion', null).then(async (version) => {
        const cookies = new Cookies();
        var cookie = cookies.get('ssp_build_version');
        if (cookie === undefined || cookie !== version) {
            logInfoToDatabase("Version update, local: '" + cookie + "' server: '" + version + "' logging out and clearing cache");
            cookies.set('ssp_build_version', version, { path: '/' });
            RefreshCacheAndReload(false);   //Clear cache & signout, but do not change route (Let protected routes handle redirect)!
        }
        else {
            loadCustomerData(dispatch, store.getState, true, 3000);
            loadLifeCustomerData(dispatch, store.getState, true, 3000);
        }
        dispatch({
            type: SET_APP_VERSION, payload: version
        });
    });
    await dispatch({ type: LOADING_SCREEN_HIDE });
}

export const RefreshCacheAndReload = async (navigateToLogin: boolean = true) => {
    if (caches !== undefined) {
        const dispatch = store.dispatch;
        if (caches) {
            caches.keys().then(function (names) {
                for (let name of names) caches.delete(name);
            });
        }
        await window.localStorage.clear();
        await dispatch(signOut(navigateToLogin));
        await window.location.reload();
    }
}

export const setIsLivinEnabled = async () => {
    const dispatch = store.dispatch;
    await getFromController(dispatch, 'IsLivinEnabled', null).then(async (response) => {
        dispatch({
            type: SET_IS_LIVIN_ENABLED, payload: response
        });
    });
}

export const setFeaturesEnabled = async () => {
    const dispatch = store.dispatch;
    await getFromController(dispatch, 'GetEnabledFeatures', null).then(async (response) => {
        for (let i = 0; i < response.length; i++) {
            await dispatch({
                type: SET_FEATURES, payload: { [response[i].featureName]: response[i].flagValue }
            });
        }
    });
}

export const setSettings = async () => {
    const dispatch = store.dispatch;
    await getFromController(dispatch, 'GetSettings', null).then(async (response) => {
        for (let i = 0; i < response.length; i++) {
            await dispatch({
                type: SET_SETTINGS, payload: { [response[i].name]: response[i].value }
            });
        }
    });
}

export const setApplicationId = async () => {
    const dispatch = store.dispatch;
    await getFromController(dispatch, 'ApplicationId', null).then(async (response) => {
        dispatch({
            type: SET_APP_ID, payload: response
        });
    });
}

export const setCountry = async () => {
    const dispatch = store.dispatch;
    await getFromController(dispatch, 'CountryId', null).then(async (response) => {
        dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                countryId: response,
                currencySymbol: (response === 157) ? 'N$' : 'R'
            }
        });
        if (response === 157) {

            await dispatch({
                type: SET_I18N_DATA, payload: {
                    lat: NAM_LAT,
                    long: NAM_LONG,
                    address1: NAM_ADDRESS1,
                    address2: NAM_ADDRESS2,
                    address3: NAM_ADDRESS3,
                    address4: NAM_ADDRESS4,
                    contactUs_tel: NAM_TEL,
                    clientcare_email: NAM_CLIENT_CARE_EMAIL,
                    claims_email: NAM_CLAIMS_EMAIL,
                    sales_email: NAM_SALES_EMAIL,
                    fsp_license: NAM_KP_FSP,
                }
            });
        } else { //Always default to SA 
            await dispatch({
                type: SET_I18N_DATA, payload: {
                    lat: SA_LAT,
                    long: SA_LONG,
                    address1: SA_ADDRESS1,
                    address2: SA_ADDRESS2,
                    address3: SA_ADDRESS3,
                    address4: SA_ADDRESS4,
                    contactUs_tel: SA_TEL,
                    clientcare_email: SA_CLIENT_CARE_EMAIL,
                    claims_email: SA_CLAIMS_EMAIL,
                    sales_email: SA_SALES_EMAIL,
                    fsp_license: SA_KP_FSP,
                }
            });
        }
    });
}

export const isSouthAfrica = async (): Promise<boolean> => {
    let isSA = false
    const dispatch = store.dispatch;
    await getFromController(dispatch, 'CountryId', null).then(async (response) => {
        if (response === 244) {
            isSA = true
        }
    });
    return isSA
}

export const setGuestData = (payload) => {
    return (dispatch) => {
        dispatch({
            type: SET_GUEST_LOGIN_DATA, payload: payload
        });
    }
}

export const setSSPData = (payload) => {
    return (dispatch) => {
        dispatch({
            type: SET_SSP_DATA, payload: payload
        });
    }
}

export const getAsLocalCurrency = (value: any, addCurrencySymbol: boolean = true) => {
    return (dispatch, getState) => {
        let symbol = getState().profile.currencySymbol;
        let number = Number(value.toString().match(/\d*\.?\d/g)?.join(''));
        return (addCurrencySymbol ? symbol + " " : "") + new Intl.NumberFormat("en-UK").format(number);
    }
}

export const redirectToUrl = (url: any) => {
    return (dispatch) => {
        dispatch(setSSPData({ reloadOnUnmount: false }));
        window.location.href = url;
    }
}